// extracted by mini-css-extract-plugin
module.exports = {"badge":"_3IIT9","small":"nTqn7"};